(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = ['always', 'reduce-logo-size'].includes(this.dataset.stickyType);
      this.currentScrollTop = 0;
      this.headerBounds = this.header.getBoundingClientRect();
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScrollHandler); }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom && !this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.currentScrollTop = scrollTop;
    }
  }
  customElements.define('sticky-header', StickyHeader);

  (() => {
    document.querySelectorAll('[data-announcement-rotation]').forEach((bar) => {
      if (bar.dataset.announcementInitialized === 'true') return;
      bar.dataset.announcementInitialized = 'true';
      const items = [...bar.querySelectorAll('.birei-announcement__item')];
      const previousButton = bar.querySelector('[data-announcement-previous]');
      const nextButton = bar.querySelector('[data-announcement-next]');
      if (items.length < 2) {
        bar.querySelector('.birei-announcement__controls')?.remove();
        return;
      }

      let current = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
      let timer;
      let paused = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const update = (nextIndex) => {
        items[current].classList.remove('is-active');
        items[current].setAttribute('aria-hidden', 'true');
        current = (nextIndex + items.length) % items.length;
        items[current].classList.add('is-active');
        items[current].setAttribute('aria-hidden', 'false');
        previousButton?.setAttribute('aria-controls', items[current].id);
        nextButton?.setAttribute('aria-controls', items[current].id);
      };
      const next = () => update(current + 1);
      const previous = () => update(current - 1);
      const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
      const start = () => {
        stop();
        if (!paused && !reducedMotion.matches) timer = window.setInterval(next, Number(bar.dataset.interval) || 3000);
      };
      const pause = () => { paused = true; stop(); };
      const resume = () => { paused = false; start(); };

      previousButton?.addEventListener('click', () => { previous(); start(); });
      nextButton?.addEventListener('click', () => { next(); start(); });
      bar.addEventListener('mouseenter', pause);
      bar.addEventListener('mouseleave', resume);
      bar.addEventListener('focusin', pause);
      bar.addEventListener('focusout', (event) => {
        if (!bar.contains(event.relatedTarget)) resume();
      });
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      reducedMotion.addEventListener?.('change', start);
      bar.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); previous(); start(); }
        if (event.key === 'ArrowRight') { event.preventDefault(); next(); start(); }
      });
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
